import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-y border-gold/40 bg-ivory" data-id="element-83" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-84" data-mp="9sry9ljmga6w">
        <Reveal className="mx-auto flex max-w-2xl flex-col items-center gap-1.5 rounded-xl border-2 border-gold bg-white p-3 text-center sm:p-5" data-id="element-85" data-mp="etplicjhnuf9">
          <p className="text-[0.62rem] font-extrabold uppercase tracking-[0.22em] text-navy/80 sm:text-[0.7rem]" data-id="element-86" data-mp="jqg2r3714w29">
            Tu inversión está protegida
          </p>
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy" data-id="element-87" data-mp="sm5iowppky89">
            <ShieldCheckIcon size={22} className="text-gold" data-id="element-88" data-mp="xim77s0tlelv" />
          </span>
          <h2 id="garantia" className="font-display text-base font-black uppercase leading-tight text-navy sm:text-xl" data-id="element-89" data-mp="12jtelpz1wbs0">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="text-[0.75rem] leading-snug text-navy sm:text-[0.85rem]" data-id="element-90" data-mp="25sykisunfih8">
            Tienes 7 días para explorar los 6 módulos y los 5 bonos. Si
            consideras que el sistema no es adecuado para ti, puedes solicitar un
            reembolso dentro del período establecido según los términos de
            devolución.
          </p>
        </Reveal>
      </div>
    </section>;
}